import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  loading?: boolean;
  onConfirm: () => void;
};

export const JobPostFilledConfirmDialog = ({ loading, onConfirm }: Props) => {
  const { t } = useTranslation(['jobPosts']);

  return (
    <AlertDialog.Body status="success">
      <AlertDialog.Title>{t('jobPosts:contextMenu.dialogs.filled.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('jobPosts:contextMenu.dialogs.filled.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button loading={loading} onClick={onConfirm}>
          {t('jobPosts:contextMenu.dialogs.filled.actions.confirm')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
